export default "__VITE_ASSET__2ff2d150__"